import { createVNode as d, mergeProps as e } from "vue";
import n from "../node_modules/@pf-ui/pf-icon-svg/es/asn/UploadOutlinedStandard.js";
import l from "../components/PfIcon.js";
const t = (r, a) => {
  const o = {
    ...r,
    ...a.attrs
  };
  return d(l, e(o, {
    icon: n
  }), null);
};
t.displayName = "UploadOutlinedStandard";
t.inheritAttrs = !1;
export {
  t as default
};
